<div class="card-toggle-group">
    @for (option of options(); track option.value) {
        <app-cerrix-toggle-card
            class="card-toggle-option"
            [class.selected]="option.value === selectedValue()"
            [selected]="option.value === selectedValue()"
            [ariaLabel]="option.label"
            [attr.data-uiid]="'card-toggle-option-' + option.value"
            (clickEvent)="onOptionClick(option)"
        >
            <span class="title">{{ option.label }}</span>
            @if (option.description) {
                <span class="description">{{ option.description }}</span>
            }
            @if (cardContentTemplate) {
                <div class="card-content">
                    <ng-container
                        [ngTemplateOutlet]="cardContentTemplate"
                        [ngTemplateOutletContext]="{ $implicit: option }"
                    ></ng-container>
                </div>
            }
        </app-cerrix-toggle-card>
    }
</div>
